import { createSelector } from "redux-starter-kit";

export default createSelector(
  ["signup.exchangePlaidError"],
  error => error
);
